<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div class="search-class">
      <el-form
        :model="searchTxt"
        :inline="true"
        size="small"
        class="serarch-form"
        label-width="90px"
      >
        <div>
          <el-form-item label="退款状态">
            <el-button
              @click="typeClick('')"
              :class="searchTxt.refundStatus === '' ? 'activeClass' : ''"
            >
              全部
            </el-button>
            <el-button
              :class="searchTxt.refundStatus === item.key ? 'activeClass' : ''"
              v-for="(item, index) in dropList.refundStatusCount"
              :key="index"
              @click="typeClick(item, index)"
            >
              {{ dropList.refundStatusList[item.key] }}&nbsp;
              <span class="spanText-error">{{ item.value }}</span>
            </el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="是否全款">
            <el-select
              v-model="searchTxt.isFull"
              clearable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, i) in ['是', '否']"
                :label="val"
                :value="i + 1"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="display: flex">
              <el-select
                v-model="nameKey"
                placeholder="请选择"
                class="width110"
                @change="setNameInput"
              >
                <el-option
                  v-for="(val, i) in nameTxt"
                  :label="val.name"
                  :value="val.key"
                  :key="i"
                ></el-option>
              </el-select>
              <el-select
                v-model="nameValue"
                placeholder="请选择"
                class="input-width"
                filterable
                clearable
              >
                <el-option
                  v-for="(val, key, i) in dropList.userList"
                  :label="val"
                  :value="key"
                  :key="i"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="display: flex">
              <el-select
                v-model="inputKey"
                placeholder="请选择"
                class="width110"
                @change="setInput"
              >
                <el-option
                  v-for="(val, i) in inputTxt"
                  :label="val.name"
                  :value="val.key"
                  :key="i"
                ></el-option>
              </el-select>
              <el-input
                class="input-width"
                placeholder="请输入"
                v-model.trim="numberTxt"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="display: flex">
              <el-select
                v-model="timeKey"
                placeholder="请选择"
                class="width110"
                @change="setTimeValue"
              >
                <el-option
                  v-for="(val, i) in ['发起时间', '审核时间', '作废时间']"
                  :label="val"
                  :value="i"
                  :key="i"
                ></el-option>
              </el-select>
              <el-date-picker
                v-model="startDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                class="input-width"
              >
              </el-date-picker>
              -
              <el-date-picker
                v-model="endDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                class="input-width"
              >
              </el-date-picker>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="退款原因">
          <div style="display: flex">
            <el-select
              v-model="classAtxt"
              clearable
              placeholder="请选择"
              class="input-width"
              style="margin-right: 10px"
              @change="setReason"
            >
              <el-option
                v-for="(val, key, i) in classA.primaryReason"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchTxt.refundReason"
              placeholder="请先选择一级原因"
              :disabled="classAtxt == '' ? true : false"
              class="input-width"
              clearable
            >
              <el-option
                v-for="(val, i) in secondLevel"
                :label="val"
                :value="i"
                :key="i"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()" icon="el-icon-search"
            >查找</el-button
          >
          <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="main-table">
      <div class="table-header">
        <exportComment
          v-if="$buttonAuthority(allButton, 'export')"
          :url="'/crm/yy-ebay-refund/exportCsv'"
          :param="searchTxt"
          :fileName="'eBay退款单_'"
          :requestType="'post'"
        ></exportComment>
        <el-button
          @click="batchVoid"
          class="button-class"
          type="primary"
          v-if="$buttonAuthority(allButton, 'batchVoid')"
          >批量作废</el-button
        >
        <el-button
          @click="batchRepush()"
          class="button-class"
          type="warning"
          v-if="$buttonAuthority(allButton, 'batchRepush')"
          >批量重推</el-button
        >
        <el-button
          @click="refund"
          class="button-class"
          type="warning"
          v-if="$buttonAuthority(allButton, 'refund')"
          >发起退款</el-button
        >
      </div>
      <commonTable
        ref="multipleTable"
        type="selection"
        :isExpand="false"
        :loading="loading"
        :tableData="tableData"
        :tableLabel="tableLabel"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pagination.pageSize"
        :currentPage="pagination.page"
        :total="pagination.total"
        :tableOption="tableOption"
        @handleButton="handleButton"
        @handleSelectionChange="handleSelectionChange"
      >
        <template slot-scope="data">
          <el-button
            size="mini"
            v-if="
              $buttonAuthority(allButton, 'void') && data.row.refundStatus === 1
            "
            type="text"
            @click="voidClick(data.row)"
            >作废</el-button
          >
          <el-button
            size="mini"
            v-if="
              $buttonAuthority(allButton, 'audit') &&
              data.row.refundStatus === 1
            "
            type="text"
            @click="auditClcik(data.row)"
            >审核</el-button
          >
          <el-button
            size="mini"
            v-if="
              $buttonAuthority(allButton, 'repush') &&
              data.row.refundStatus === 3
            "
            type="text"
            @click="repushClcik(data.row)"
            >重推</el-button
          >
        </template>
      </commonTable>
    </div>
    <applyRefund
      v-if="isRefund"
      @isShowEdit="isShowEdit"
      :scope="scope"
      @getList="getList"
      :platform="platform"
    ></applyRefund>
    <toVoid
      v-if="isVoid"
      @isShowEdit="isShowEdit"
      :refundIds="refundIds"
      @getList="getList"
      :platform="platform"
    ></toVoid>
    <audit
      v-if="isAudit"
      @isShowEdit="isShowEdit"
      @getList="getList"
      :ids="ids"
    ></audit>
    <showLog
      v-if="isLog"
      @isShowEdit="isShowEdit"
      :scope="scope"
      @getList="getList"
    ></showLog>
  </div>
</template>
<script>
/**
 * eBay 退款单列表页
 * 功能：功能与 Amazon 退款单页对应（发起退款、批量作废、批量重推、作废/审核/重推/日志），额外展示推送 OMS/eBay 状态列。
 */
import {
  getBaseRefundReason,
  getEbayRefundList,
  repushEbayOrder,
} from "@/api/user";
import { getRefundTitle } from "@/utils/tableLabel";
import applyRefund from "../components/applyRefund.vue";
import toVoid from "../components/toVoid.vue";
import audit from "../components/ebayAudit.vue";
import showLog from "../components/showLog.vue";
export default {
  components: {
    applyRefund,
    toVoid,
    audit,
    showLog,
  },
  data() {
    return {
      platform: 2, // ebay平台id
      refundStatusArr: [],
      active: "",
      // 是否显示发起退款弹窗
      isRefund: false,
      // 是否显示作废弹窗
      isVoid: false,
      // 是否显示审核弹窗
      isAudit: false,
      // 是否显示日志弹窗
      isLog: false,
      // 页面按钮权限列表
      allButton: [],
      // 表格加载状态
      loading: true,
      // 是否首次加载（首次用于初始化列配置）
      isFirst: true,
      refundIds: [], // 退款单单号
      ids: [], // 退款单id
      // 选中的行数据（传给弹窗组件）
      scope: {},
      // 表格数据
      tableData: [],
      // 表格列配置
      tableLabel: [],
      // 后端返回的表头映射
      titleMap: [],
      // 下拉数据（退款状态/用户列表/退款原因等）
      dropList: {},
      // 后端返回的渲染列表数据
      renderList: {},
      // 一级退款原因 key
      classAtxt: "",
      classA: {}, // 一级原因
      secondLevel: {}, // 二级原因
      // 单号查询
      inputKey: "refundId",
      numberTxt: "",
      inputTxt: [
        { name: "退款单号", key: "refundId" },
        { name: "订单编号", key: "orderId" },
        { name: "平台订单号", key: "platformOrderId" },
        { name: "SKU", key: "sku" },
      ],
      // 操作人查询
      nameKey: "createUser",
      nameValue: "",
      nameTxt: [
        { name: "发起人", key: "createUser" },
        { name: "审核人", key: "auditUser" },
        { name: "作废操作人", key: "invalidUser" },
      ],
      // 操作时间查询
      timeKey: 0,
      startDate: "",
      endDate: "",
      // 搜索条件
      searchTxt: {
        refundStatus: "",
        isFull: "",
        refundReason: "",
        createUser: "",
        startCreateAt: "",
        endCreateAt: "",
        auditUser: "",
        startAuditAt: "",
        endAuditAt: "",
        invalidUser: "",
        startInvalidAt: "",
        endInvalidAt: "",
        refundId: "",
        orderId: "",
        platformOrderId: "",
        sku: "",
      },
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格勾选的行数据（用于批量作废/重推）
      dataList: [],
      // 表格操作列配置（日志）
      tableOption: {
        label: "操作",
        width: "100",
        fixed: "right",
        options: [
          {
            label: "日志",
            type: "text",
            methods: "log",
            size: "mini",
          },
        ],
      },
    };
  },
  /** 初始化按钮权限、列表数据、列配置与退款原因下拉（注意：getTableLabel 在 getList 之前调用，此时 dropList 为空，列配置需首次请求后再生成） */
  created() {
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      this.getList();
      this.getTableLabel();
      this.init();
    }
  },
  methods: {
    /** 拉取退款原因字典（一二级原因） */
    init() {
      getBaseRefundReason().then((res) => {
        if (res.code === 200) {
          this.classA = res.data;
          // .primaryReason; // 一级原因
          // this.secondLevel = res.data.secondaryReason; // 二级原因
        }
      });
    },
    /** 选择一级退款原因时联动加载对应的二级原因
     * @param {String} val 一级原因 key
     */
    setReason(val) {
      if (val === "") {
        this.searchTxt.refundReason = "";
      }
      this.secondLevel = this.classA.secondaryReason[val];
    },
    /** 切换操作人查询字段时清空之前的操作人条件 */
    setNameInput() {
      this.$delectObj(this.searchTxt, [
        "createUser",
        "auditUser",
        "invalidUser",
      ]);
      this.nameValue = "";
    },
    /** 切换操作时间查询字段时清空之前的时间条件 */
    setTimeValue(val) {
      this.$delectObj(this.searchTxt, [
        "startCreateAt",
        "endCreateAt",
        "startAuditAt",
        "endAuditAt",
        "startInvalidAt",
        "endInvalidAt",
      ]);
      this.startDate = this.endDate = "";
    },
    /** 切换单号查询字段时清空之前的单号输入 */
    setInput(val) {
      this.searchTxt.orderId = "";
      this.searchTxt.platformOrderId = "";
      this.searchTxt.refundId = "";
      this.numberTxt = "";
    },
    /** 根据公共列配置生成表格列，并替换退款原因列、插入推送 OMS/eBay 状态列 */
    getTableLabel() {
      this.tableLabel = getRefundTitle(this.dropList, this);
      let refundReason = {
        label: "退款原因",
        param: "refundReason",
        align: "left",
        show: true,
        render: (h, param) => {
          let parentId = h(
            "p",
            "一级原因：" +
              this.$getText(
                param.row.parentId,
                this.dropList.refundReasonListL1
              )
          );
          let reason = h(
            "p",
            "二级原因：" +
              this.$getText(
                param.row.refundReason,
                this.dropList.refundReasonList
              )
          );
          return h("div", [parentId, reason]);
        },
      };
      let isOrderStr = {
        label: "推送信息",
        param: "isOrderStr",
        align: "center",
        show: true,
        render: (h, param) => {
          let isOrderStr = h("p", "是否推送至OMS：" + param.row.isOrderStr);
          let isPushEabyStr = h(
            "p",
            "是否推送至eBay：" + param.row.isPushEabyStr
          );
          return h("div", [isOrderStr, isPushEabyStr]);
        },
      };
      this.tableLabel.splice(9, 1, isOrderStr);
      this.tableLabel.splice(6, 1, refundReason);
      this.loading = false;
    },
    /** 查询退款单列表 */
    getList() {
      this.loading = true;
      getEbayRefundList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.pagination.total = result.data.pageInfo.total;
          this.dropList = result.data.dropList;
          let label = result.data.renderList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap;
            this.getTableLabel();
          } else {
            this.loading = false;
          }
          this.$refs.multipleTable.clear();
        }
      });
    },
    // 根据退款状态查询
    typeClick(item, index) {
      this.searchTxt.refundStatus = item == "" ? item : item.key;
      this.search();
    },
    /** 批量作废：校验勾选数据均为待审核状态后打开作废弹窗 */
    batchVoid() {
      // 操作状态=待审核
      let arr = this.dataList.map((item) => {
        return item.refundStatus === 1 ? true : false;
      });
      if (this.dataList.length <= 0) {
        return this.$message.warning("请选择需要操作的数据项！");
      } else if (arr.indexOf(false) >= 0) {
        return this.$message.warning("请选择退款状态为待审核的数据项！");
      } else {
        this.isVoid = true;
      }
    },
    /** 批量重推：校验勾选数据均为退款失败状态后弹窗确认重推 */
    batchRepush() {
      // 操作状态=退款失败
      let arr = this.dataList.map((item) => {
        return item.refundStatus === 3 ? true : false;
      });
      if (this.dataList.length <= 0) {
        return this.$message.warning("请选择需要操作的数据项！");
      } else if (arr.indexOf(false) >= 0) {
        return this.$message.warning("请选择退款状态为退款失败的数据项！");
      } else {
        // 操作状态=退款失败
        let obj = {
          ids: this.dataList.map((item) => item.id),
        };
        this.pushInfo(obj);
      }
    },
    /** 打开发起退款弹窗（订单号在弹窗内手动输入） */
    refund() {
      this.isRefund = true;
    },
    /** 关闭所有弹窗并清空选中数据 */
    isShowEdit() {
      this.isRefund = false;
      this.isVoid = false;
      this.isLog = false;
      this.isAudit = false;
      this.scope = {};
      this.refundIds = [];
      this.ids = [];
      this.$refs.multipleTable && this.$refs.multipleTable.clear();
    },
    /** 表格操作列按钮分发（日志）
     * @param {Object} data 操作信息（methods 为按钮标识，row 为行数据）
     */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "log") {
        this.logInfo(data.row);
      }
    },
    /** 单行作废：打开作废弹窗
     * @param {Object} val 选中的退款单行数据
     */
    voidClick(val) {
      // 操作状态=待审核
      this.isVoid = true;
      this.scope = val;
      this.refundIds = [val.refundId];
    },
    /** 单行审核：打开审核弹窗
     * @param {Object} val 选中的退款单行数据
     */
    auditClcik(val) {
      // 操作状态=待审核
      this.isAudit = true;
      this.scope = val;
      this.ids = [val.id];
    },
    /** 单行重推：组装退款单 id 后弹窗确认重推
     * @param {Object} val 选中的退款单行数据
     */
    repushClcik(val) {
      // 操作状态=退款失败
      let obj = {
        ids: [val.id],
      };
      this.pushInfo(obj);
      this.scope = val;
    },
    /** 弹窗确认后将退款单重新推送至 eBay 平台
     * @param {Object} obj 退款单 id 列表 { ids: [...] }
     */
    pushInfo(obj) {
      this.$msgbox({
        title: "重推",
        message: "此操作会重新将退款单推送至Ebay平台，是否确定？",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中，请勿关闭！";
            // instance.showClose = false;
            // instance.showCancelButton = false;
            repushEbayOrder(obj.ids)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.msg);
                  this.getList();
                  done();
                  instance.confirmButtonLoading = false;
                }
              })
              .catch(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
            instance.confirmButtonLoading = false;
          }
        },
      })
        .then(() => {})
        .catch(() => {});
    },
    // 日志
    logInfo(val) {
      this.isLog = true;
      this.scope = val;
    },
    /** 每页条数变化时重新查询
     * @param {Number} value 每页条数
     */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询
     * @param {Number} value 当前页码
     */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 表格勾选变化，更新批量作废/重推的数据
     * @param {Array} value 勾选的行数据
     */
    handleSelectionChange(value) {
      this.dataList = value;
      this.refundIds = value.map((item) => item.refundId);
      this.ids = value.map((item) => item.id);
    },
    /** 按当前输入条件（状态/操作人/单号/时间/原因）查询退款单 */
    search() {
      this.searchTxt[this.nameKey] = this.nameValue;
      this.searchTxt[this.inputKey] = this.numberTxt;
      // 获取时间
      switch (this.timeKey) {
        case 0:
          this.searchTxt.startCreateAt = this.startDate;
          this.searchTxt.endCreateAt = this.endDate;
          break;
        case 1:
          this.searchTxt.startAuditAt = this.startDate;
          this.searchTxt.endAuditAt = this.endDate;
          break;
        case 2:
          this.searchTxt.startInvalidAt = this.startDate;
          this.searchTxt.endInvalidAt = this.endDate;
          break;
      }
      this.pagination.page = 1;
      Object.assign(this.pagination, this.searchTxt);
      this.isFirst = false;
      this.getList();
    },
    /** 重置查询条件并重新加载列表 */
    reset() {
      this.$delectObj(this.searchTxt);
      this.$delectObj(this.pagination, [
        "createUser",
        "auditUser",
        "invalidUser",
        "startCreateAt",
        "endCreateAt",
        "startAuditAt",
        "endAuditAt",
        "startInvalidAt",
        "endInvalidAt",
        "refundStatus",
        "isFull",
        "refundReason",
        "refundId",
        "orderId",
        "platformOrderId",
        "sku",
      ]);
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.isFirst = false;
      this.nameValue = this.startDate = this.endDate = this.classAtxt = "";
      this.nameKey = "createUser";
      this.timeKey = 0;
      this.numberTxt = "";
      this.inputKey = "refundId";
      this.getList();
    },
    /** 按按钮权限过滤表格操作列（疑似死代码：本页从未调用，日志按钮权限未过滤） */
    tableOptionAuth() {
      let array = this.tableOption.options;
      let authOption = [];
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element);
        }
      });
      if (authOption.length > 0) {
        this.tableOption.options = authOption;
      } else {
        this.tableOption = {};
      }
    },
  },
};
</script>
<style lang="scss">
.width110 {
  width: 110px !important;
  margin-right: 10px;
}
</style>